export const PAGE_SIZE = 10;

export const COUNTRIES = [
  "ae",
  "ar",
  "at",
  "au",
  "be",
  "bg",
  "br",
  "ca",
  "ch",
  "cn",
  "co",
  "cu",
  "cz",
  "de",
  "eg",
  "fr",
  "gb",
  "gr",
  "hk",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "it",
  "jp",
  "kr",
  "lt",
  "lv",
  "ma",
  "mx",
  "my",
  "ng",
  "nl",
  "no",
  "nz",
  "ph",
  "pl",
  "pt",
  "ro",
  "rs",
  "ru",
  "sa",
  "se",
  "sg",
  "si",
  "sk",
  "th",
  "tr",
  "tw",
  "ua",
  "us",
  "ve",
  "za"
];

export const CATEGORIES = [
  "business",
  "entertainment",
  "general",
  "health",
  "science",
  "sports",
  "technology"
];

export const LANGUAGES = [
  "ar",
  "de",
  "en",
  "es",
  "fr",
  "he",
  "it",
  "nl",
  "no",
  "pt",
  "ru",
  "se",
  "ud",
  "zh"
];

export const DATE_FORMAT = "DD MMM YYYY";
export const TIME_FORMAT = "hh:mm a";
export const DATETIME_FORMAT = "DD/MM/YYYY hh:mm a";

export const GRID_MODES = {
  TABLE: "TABLE",
  ROW: "ROW",
  CARDS: "CARDS"
};

export const ARTICLE_MODES = {
  TITLE_ONLY: "TITLE_ONLY",
  IN_TABLE: "IN_TABLE",
  CARD: "CARD",
  ROW: "ROW"
};

export const COLORS = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#24ff15",
  "#AF4042",
  "#0A8042",
  "#EC8142",
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#d62728",
  "#9467bd",
  "#8c564b",
  "#e377c2",
  "#7f7f7f",
  "#bcbd22",
  "#87becf",
  "#005C4b",
  "#e377c2",
  "#ecef7f",
  "#bc3d22",
  "#87baaa"
];
